export default __webpack_public_path__ + "static/media/fastfood_purple_24px.7f13bc1e.svg";